import React from "react";
import intl from "react-intl-universal";
import { useParams, Redirect } from "react-router-dom";
import { useGet } from "restful-react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import { useHistory } from "react-router-dom";
import moment from "moment-timezone";

import { IMatchWithballDataResponse, getTeamWithballlData } from "apis";
import { Heading } from "components/Heading";
import { getUsersFromWithballRawData, getYearBoundaryInUtc } from "utils";
import { routing } from "routing";

import { TeamDataOverview } from "../TeamDataOverview";
import { PlayerDataView } from "../PlayerDataView";

const TEAM_VALUE = "0";

const { Urls } = routing;

export const TeamStats = () => {
  const { teamId, playerId } = useParams<{
    teamId: string;
    playerId: string;
  }>();
  const year = moment().year();
  const range = getYearBoundaryInUtc(year.toString());

  const history = useHistory();
  const { data } = useGet<IMatchWithballDataResponse>({
    path: getTeamWithballlData(teamId.toString(), [], range.from, range.to),
  });

  const players = getUsersFromWithballRawData(data?.withballData || [], true);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    history.push(
      newValue === TEAM_VALUE
        ? Urls.TEAM_STATS(teamId)
        : Urls.TEAM_PLAYER_STATS(teamId, newValue)
    );
  };

  const currentId = playerId || TEAM_VALUE;

  if (
    currentId !== TEAM_VALUE &&
    !players.find((player) => player.id.toString() === currentId)
  ) {
    return <Redirect to={Urls.TEAM_STATS(teamId)} />;
  }

  return (
    <>
      <Heading title={intl.get("STATS_TEAM_TITLE", { year })} />
      <AppBar position="static">
        <Tabs value={currentId} onChange={handleTabChange} variant="scrollable">
          <Tab
            key={TEAM_VALUE}
            label={intl.get("MATCH_STATS_TEAM_OVERALL")}
            value={TEAM_VALUE}
          />
          {players.map((player) => (
            <Tab
              key={player.id}
              label={player.name || intl.get("MATCH_STATS_UNKNOWN_PLAYER")}
              value={player.id.toString()}
            />
          ))}
        </Tabs>
      </AppBar>
      <Box mt={2} />
      {currentId === TEAM_VALUE ? (
        <TeamDataOverview forMultiGames dataArray={data?.withballData || []} />
      ) : (
        <PlayerDataView
          dataArray={data?.withballData || []}
          playerId={currentId}
        />
      )}
    </>
  );
};
